import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges, ViewChild } from '@angular/core';
import { NgStyle, NgClass } from '@angular/common';

@Component({
  selector: 'app-cd-carousel',
  templateUrl: './cd-carousel.component.html',
  styleUrls: ['./cd-carousel.component.scss'],
  imports: [NgStyle, NgClass],
})
export class CdCarouselComponent implements OnChanges, AfterViewInit, OnDestroy {
  @Input() list: unknown[] = [];
  @Input() itemKey: (item: unknown) => unknown = item => item;
  @ViewChild('carouselBox', { static: true }) carouselBox!: ElementRef<HTMLElement>;
  currentIndexSlides = 0;
  slidesTouchStartX = 0;
  slidesTouchEndX = 0;
  private autoSlideInterval?: ReturnType<typeof setInterval>;
  private viewInitialized = false;

  ngOnChanges(changes: SimpleChanges): void {
    const listChange = changes['list'];
    if (!listChange) {
      return;
    }

    const previousList = (listChange.previousValue as unknown[] | undefined) || [];
    const selectedItem = previousList[this.currentIndexSlides];
    if (selectedItem !== undefined) {
      const selectedKey = this.itemKey(selectedItem);
      const retainedIndex = this.list.findIndex(item => Object.is(this.itemKey(item), selectedKey));
      this.currentIndexSlides = retainedIndex >= 0 ? retainedIndex : Math.min(this.currentIndexSlides, Math.max(0, this.list.length - 1));
    } else {
      this.currentIndexSlides = Math.min(this.currentIndexSlides, Math.max(0, this.list.length - 1));
    }

    this.syncTransform();
  }

  ngAfterViewInit(): void {
    this.viewInitialized = true;
    this.syncTransform();
    this.autoSlideInterval = setInterval(() => {
      this.nextSlide();
    }, 5000);
  }

  ngOnDestroy(): void {
    if (this.autoSlideInterval) {
      clearInterval(this.autoSlideInterval);
    }
  }

  showSlide(index: number) {
    if (this.list.length === 0) {
      this.currentIndexSlides = 0;
      this.syncTransform();
      return;
    }

    if (index < 0) {
      this.currentIndexSlides = this.list.length - 1;
    } else if (index >= this.list.length) {
      this.currentIndexSlides = 0;
    } else {
      this.currentIndexSlides = index;
    }

    this.syncTransform();
  }

  prevSlide() {
    this.showSlide(this.currentIndexSlides - 1);
  }

  nextSlide() {
    this.showSlide(this.currentIndexSlides + 1);
  }

  goSlide(index: number) {
    this.showSlide(index);
  }

  handleTouchStart(event: TouchEvent) {
    this.slidesTouchStartX = event.touches[0].clientX;
  }

  handleTouchMove(event: TouchEvent) {
    this.slidesTouchEndX = event.touches[0].clientX;
  }

  handleTouchEnd() {
    if (this.slidesTouchStartX - this.slidesTouchEndX > 50) {
      this.nextSlide();
    } else if (this.slidesTouchEndX - this.slidesTouchStartX > 50) {
      this.prevSlide();
    }
  }

  private syncTransform(): void {
    if (!this.viewInitialized || !this.carouselBox) {
      return;
    }
    const offset = this.list.length > 0 ? -this.currentIndexSlides * (100 / this.list.length) : 0;
    this.carouselBox.nativeElement.style.transform = `translateX(${offset}%)`;
  }
}
